import HireReasons from './HireReasons'

export default HireReasons
